import { alpha, createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#428aed", // primaryButton from mobile theme
            light: "#9696FA", // primaryLight from mobile theme
            dark: "#206dfe", // primary from mobile theme
        },
        secondary: {
            main: "#6B7280", // textSecondary from mobile theme
        },
        background: {
            default: "#F9FAFB", // background from mobile theme
            paper: "#FFFFFF", // surface from mobile theme
        },
        text: {
            primary: "#111827", // textPrimary from mobile theme
            secondary: "#6B7280", // textSecondary from mobile theme
        },
        error: {
            main: "#EF4444", // error from mobile theme
        },
        warning: {
            main: "#F59E0B", // warning from mobile theme
        },
        success: {
            main: "#32cd32", // success from mobile theme
        },
    },
    typography: {
        fontSize: 13,
        h5: { fontSize: "1.15rem", fontWeight: 700 },
        h6: { fontSize: "1rem", fontWeight: 700 },
        subtitle1: { fontSize: "0.9rem" },
        subtitle2: { fontSize: "0.85rem" },
        body1: { fontSize: "0.9rem" },
        body2: { fontSize: "0.85rem" },
        caption: { fontSize: "0.75rem" },
        button: { fontSize: "0.85rem", fontWeight: 600 },
    },
    shape: {
        borderRadius: 10,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                    backgroundAttachment: "fixed",
                    minHeight: "100vh",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderRadius: 14,
                    borderColor: alpha(theme.palette.common.black, 0.08),
                }),
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderColor: alpha(theme.palette.common.black, 0.08),
                }),
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: ({ theme }) => ({
                    borderColor: alpha(theme.palette.common.black, 0.12),
                }),
                root: ({ theme }) => ({
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: alpha(theme.palette.common.black, 0.2),
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.primary.main,
                    },
                }),
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderBottomColor: alpha(theme.palette.common.black, 0.08),
                    paddingTop: 10,
                    paddingBottom: 10,
                }),
                head: ({ theme }) => ({
                    fontSize: "0.72rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: theme.palette.text.secondary,
                }),
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: "10px",
                    boxShadow: "none",
                    fontWeight: 700,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                },
            },
        },
    },
});

export default theme;
